module.exports = __webpack_public_path__ + "static/media/Tentacle_Resist_Opening.a0e5f5ba.mp3";